import { createFileRoute } from '@tanstack/react-router';

import { MembersPage } from '@/features/members/pages';

export const Route = createFileRoute('/_authenticated/_withWorkspace/settings/members')({
  component: MembersPage,
});

